import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
import { ALL_ITEM_JEWELRYBOXES } from "./itemJson";
import ItemList from "../../itemListContainer/itemList";


function JewelryBoxesPage(props) {
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    const jewelsParam = props.match.params.jewels;
    const filtered = ALL_ITEM_JEWELRYBOXES[0].itemList.filter(item => item.itemSelected === jewelsParam);
    setSelectedItem(filtered)
  }, [props.match.params.jewels]); 


  return (
    <>
      <Helmet>
        <title>Custom Jewelry Packaging Boxes Manufacturer | Lussopack</title>
        <meta name="description" content="Find your perfect customized jewelry box set and packaging. Available in various colors and crafted from high-quality and eco-friendly materials." />
        <meta name="keywords" content="Jewelry Packaging Boxes" />
        <meta name="robots" content="noindex" />
        <link rel="canonical" href="https://lussopack.com/packaging/jewelry-boxes/" />
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"Custom Luxury Jewelry Packaging Boxes"}
        textSubHeader={"Our custom jewelry packaging boxes are designed to showcase and protect your precious jewelry with unmatched craftsmanship and luxurious materials."}
      />        
      <ItemList 
        selectedItem={selectedItem}
      />
    </>
  );
}

export default JewelryBoxesPage;
